import React from 'react';
import SvgNoSearchResults from '../internals/svg/NoSearchResults';
const SovosNoSearchResultsIllustration = props => /*#__PURE__*/React.createElement(SvgNoSearchResults, props);
export default SovosNoSearchResultsIllustration;